export const PRICE_PER_ROOM = 49;
export const DISTRIBUTOR = 'distributor';
export const ADMIN = 'admin';